import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/sellers/inbounds/inventory_batches'

const SellerInventoryBatchesApiV2 = {

  /**
   * Create inventory batch ednpoint.
   * Invoke `POST api/v2/admins/sellers/inbounds/inventory_batches`
   * @param {string} photo_studio_location location of the batch in the studio
   * @param {array} skus list of skus that will be put in one batch
   */
  create: async ({
    photo_studio_location,
    items
  }) => {
    const path     = API_PATH
    const body     = {
      inventory_batch: {
        photo_studio_location : photo_studio_location,
        items                 : items
      }
    }
    const response = axios.post(path, body)
    return response
  },

  /**
   * Get list of Seller Inventory Batch
   * Invoke `GET api/v2/admins/sellers/inbounds/inventory-batches
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get list of Seller Inventory Batch that has prefiltered status. It will
   * get just the batches that are already photography complete and beyond. So
   * this filter is different from the get Inventory Batches above
   * Invoke `GET api/v2/admins/sellers/inbounds/inventory-batches
   * @param {object} tableState - ReactTable final state\
   */
  getPhotoEdit: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/photo_editor`

    const response = axios.get(path, { params })
    return response
  },

  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  getAcceptedItems: async ({ id, tableState, additionalFilters }) => {
    const params   = QueryParamsUtil.format(tableState, additionalFilters)
    const path     = `${API_PATH}/${id}/accepted_items`
    const response = axios.get(path, { params })
    return response
  },

  getRejectedItems: async ({ id, tableState, additionalFilters }) => {
    const params   = QueryParamsUtil.format(tableState, additionalFilters)
    const path     = `${API_PATH}/${id}/rejected_items`
    const response = axios.get(path, { params })
    return response
  },

  getAllItems: async ({ tableState }) => {
    const params   = QueryParamsUtil.format(tableState)
    const path     = `${API_PATH}/items`
    const response = axios.get(path, { params })
    return response
  },

  receive: async (id) => {
    const path     = `${API_PATH}/${id}/photo_studio_received`
    const response = axios.patch(path)
    return response
  },

  completePhotography: async (id) => {
    const path     = `${API_PATH}/${id}/photo_studio_complete`
    const response = axios.patch(path)
    return response
  },

  completePhotoEdit: async (id) => {
    const path     = `${API_PATH}/${id}/photo_edit_complete`
    const response = axios.patch(path)
    return response
  },

  warehouseReceive: async (id) => {
    const path     = `${API_PATH}/${id}/warehouse_received`
    const response = axios.patch(path)
    return response
  },

  startPutAway: async (id) => {
    const path     = `${API_PATH}/${id}/start_put_away`
    const response = axios.patch(path)
    return response
  },

  endPutAway: async (id) => {
    const path     = `${API_PATH}/${id}/end_put_away`
    const response = axios.patch(path)
    return response
  },

  // items endpoint
  receiveItem: async ({ sku, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/items/photo_studio_receive`
    const payload  = {
      'inventory_batch_item': {
        'sku'                : sku,
        'inventory_batch_id' : inventory_batch_id
      }
    }

    const response = axios.post(endpoint, payload)
    return response
  },

  pendingReceivedItem: async ({ item_id, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/items/${item_id}/photo_studio_pending_receive`
    const payload  = {
      'inventory_batch_item': {
        'inventory_batch_id': inventory_batch_id
      }
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  completePhotographyItem: async ({ sku, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/items/photo_studio_complete`
    const payload  = {
      'inventory_batch_item': {
        'sku'                : sku,
        'inventory_batch_id' : inventory_batch_id
      }
    }

    const response = axios.post(endpoint, payload)
    return response
  },

  pendingPhotographyItem: async ({ item_id, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/items/${item_id}/photo_studio_pending`
    const payload  = {
      'inventory_batch_item': {
        'inventory_batch_id': inventory_batch_id
      }
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  photoEditItem: async ({ sku }) => {
    const endpoint = `${API_PATH}/items/photo_edited`
    const payload  = {
      'items': [ {
        'sku': sku
      } ]
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  putAwayItems: ({
    items,
    location_id,
    inventory_batch_id
  }) => {
    const endpoint = `${API_PATH}/items/put_away`
    const payload  = {
      'inventory_batch': {
        'inventory_batch_id' : inventory_batch_id,
        'location_id'        : location_id,
        'items'              : items
      }
    }

    const response = axios.post(endpoint, payload)
    return response
  },

  rejectPostCuration: async ({
    inventory_batch_id,
    item_id,
    reject_reason,
    reject_note
  }) => {
    const endpoint = `${API_PATH}/items/${item_id}/reject_post_curation`
    const payload  = {
      'inventory_batch_item': {
        'inventory_batch_id' : inventory_batch_id,
        'reject_reason'      : reject_reason,
        'reject_note'        : reject_note
      }
    }

    const response = axios.patch(endpoint, payload)
    return response
  }
}

export default SellerInventoryBatchesApiV2
